<template>
  <div class="public-content balance-enquiry">
    <div class="breadcrumb">余额明细</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <!-- <el-col :span="6">
            <el-form-item label="流水号:">
              <el-input v-model="formInline.tradeNo" placeholder="请输入流水号"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model.trim="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="流水号:">
              <el-input v-model="formInline.serialNo" placeholder="请输入平台名称"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="交易类型:">
              <el-select v-model="formInline.tradeType" placeholder="请选择" @change="formInline.tradeMethod = ''" clearable>
                <!-- <el-option label="全部" value="">全部</el-option> -->
                <el-option v-for="(v, k) in $config.tradeType" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易方式:">
              <el-select v-model="formInline.tradeMethod" placeholder="请选择" clearable>
                <!-- <el-option label="全部" value="">全部</el-option> -->
                <el-option v-for="(v, k) in filterTradeMethod" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="支付状态:">
              <el-select v-model="formInline.paymentStatus" placeholder="请选择">
                <el-option v-for="(v,k) in $config.paymentStatus" :key="k" :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="支付日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit(1)" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round v-if="type !== 0">导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="流水号" prop="tradeNo" fixed="left" min-width="210"></el-table-column>
          <el-table-column label="订单号" prop="outOrderNo" fixed="left" min-width="210">
            <template v-slot="scope">
              <span v-if="$hasPermission('oms:admin:order:one') && scope.row.tradeType == 'TRADE' && scope.row.tradeMethod !== 'CONSUME_VPAY_PROMO'" @click="orderInfo(scope.row)" class="color-blue">{{
                scope.row.outOrderNo }}</span>
              <span v-else>{{ scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="流水号" fixed="left" min-width="220">
            <template v-slot="scope">
              <span class="color-blue" @click="goPage(scope.row.orderId)">{{ scope.row.outOrderNo }}</span>
            </template>
</el-table-column> --> <!-- <el-table-column prop="serialNo" label="vpay流水号" min-width="220px"></el-table-column> -->
          <!-- <el-table-column prop="productName" label="产品名称" min-width="180"></el-table-column> -->
          <el-table-column prop="amount" label="金额" min-width="100">
            <!-- <template slot-scope="scope">{{ Math.floor(scope.row.amount * 100) / 100 }}</template> -->
            <template slot-scope="scope">{{ scope.row.amount }}</template>
          </el-table-column>
          <el-table-column label="交易类型" min-width="100">
            <template slot-scope="scope">{{ $config.tradeType[scope.row.tradeType] || scope.row.tradeType }}</template>
          </el-table-column>
          <el-table-column label="交易方式" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.tradeMethod === 'REFUND_CLEAN_BONUS'"></span>
              <span v-else> {{ $config.vpayTradeMethod[scope.row.tradeMethod] || scope.row.tradeMethod }} </span>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" min-width="100">
            <template slot-scope="scope">{{ $config.payType[scope.row.paymentType] || scope.row.paymentType }}</template>
          </el-table-column>
          <el-table-column prop="paymentDate" label="支付日期" min-width="170"></el-table-column>
          <el-table-column prop="addons.ACCT.balanceAfter" label="充值余额" min-width="100"></el-table-column>
          <el-table-column label="结算余额" min-width="100">
            <template slot-scope="scope">{{ Math.floor(scope.row.addons.SETTLE.balanceAfter * 100) / 100 }}</template>
          </el-table-column>
          <el-table-column prop="addons.BONUS.balanceAfter" label="礼金券" min-width="100"></el-table-column>
          <el-table-column prop="store.code" label="平台号" min-width="100">
          </el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="120">
          </el-table-column>
          <el-table-column label="业务" prop="store.salesman.fullName" min-width="110">
          </el-table-column>
          <!-- <el-table-column prop="addons.VPAY_ACCOUNT.balanceAfter" label="余额" min-width="180"></el-table-column> -->
          <!-- <el-table-column prop="addons.VPAY_BONUS.balanceAfter" label="虚拟余额" min-width="180"></el-table-column> -->
          <!-- <el-table-column label="支付状态" prop="paymentStatus" min-width="180">
            <template slot-scope="scope">{{$config.paymentStatus[scope.row.paymentStatus]||scope.row.paymentStatus}}</template>
          </el-table-column> -->
          <!-- <el-table-column prop="dateCreated" label="创建日期" min-width="180"></el-table-column> -->
          <!-- <el-table-column label="支付方式" min-width="180">
            <template slot-scope="scope">{{$config.paymentType[scope.row.paymentType]||scope.row.paymentType}}</template>
          </el-table-column> -->
        </el-table>
      </div>
      <!--分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import store from '@/store'
import { orderPage, orderExport } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
export default {
  name: 'VpayAccountOrder',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 15
      },
      formInline: {
        dateEnd: '',
        dateStart: '',
        tradeNo: '',
        salesmanId: '',
        serialNo: '',
        storeId: '',
        tradeMethod: '',
        tradeType: ''
      },
      tableData: [],
      type: store.state.systemType,
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      code: ''
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    filterTradeMethod () { // ?
      let tradeType = this.formInline.tradeType
      let rawDict = this.$config.vpayTradeMethod
      if (tradeType) {
        let destDict = {}
        if (tradeType === 'TRADE') {
          tradeType = 'CONSUME'
        }
        Object.keys(rawDict).filter(el => el.indexOf(tradeType) >= 0).forEach(k => {
          destDict[k] = rawDict[k]
        })
        // if (tradeType === 'DEDUCT') delete destDict.DEDUCT_CLEAN_BONUS
        // if (tradeType === 'REFUND') destDict.DEDUCT_CLEAN_BONUS = '清空礼金券'
        return destDict
      }
      return rawDict
    }
  },
  mounted () {
    // 余额查询-操作-余额明细
    if (this.$route.query.store) sessionStorage.setItem('epayFlag', true)
  },
  created () {
    if (this.$route.query.store) {
      this.storeListByCode = [JSON.parse(this.$route.query.store)]
      this.formInline.storeId = JSON.parse(this.$route.query.store).id
      this.onSubmit()
    } else {
      this.onSubmit()
    }
  },
  methods: {
    orderInfo (row) {
      this.$router.push({ path: '/orderdetail', query: { orderNo: row.outOrderNo, way: 1 } })
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit (num) {
      // 向后台发送post请求,获取查询数据存储在tableData
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      orderPage({ data: this.filterParams(this.formInline), params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize, descField: 'paymentDate' } }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.content
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    // 去除对象中的空value属性
    filterParams (obj) {
      let newObj = {}
      for (let val in obj) {
        if (obj[val] !== '') newObj[val] = obj[val]
      }
      return newObj
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    goPage (orderId) {
      this.$router.push({ path: './vpayAccountOrderDetail', query: { id: orderId } })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (param.dateStart === '') {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD')
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      orderExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '当前余额明细表'
          if (this.value2?.length) _fileName = _fileName + this.value2[0] + '-' + this.value2[1] + '.xls'
          if (!this.value2?.length) _fileName = _fileName + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
